import React from "react";
import { customerNameById, getPersonAge } from '../../utils'
import { DeathbenefitsBeneficiaryModal } from '../modals'
import connectWithStore from '../../utils/store'
import { store } from '../../store'
import { setInfoKey, removeSingleBeneficiary } from '../../api/information-collection/actions'

class DeathBenefitsBeneficiary extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.hasSpouse = this.hasSpouse.bind(this)
        this.removeBeneficiary = this.removeBeneficiary.bind(this)
    }

    onChangeCheckbox(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    getDeathBenefitsBeneficiaryName(initialValues, customerId, customers, fieldName){
        let insuranceTakerName = '';
        if (this.isAdult(customers, customerId)) {            
            if (fieldName in initialValues) {
                insuranceTakerName = customerNameById(initialValues[fieldName], customers)
            } else {
                insuranceTakerName = customerNameById(customerId, customers)
            }
        } else if (!this.isAdult(customers, customerId) && fieldName in initialValues){
            insuranceTakerName = customerNameById(initialValues[fieldName], customers)
        }
        return insuranceTakerName;
    }


    hasSpouse() {
        let person = this.props.nationalRegistry.data.filter(i => i.OrgId === this.props.customerId)
        if (person.length > 0) {
            person = person[0]
            if(person.SpouseOrgId && person.SpouseOrgId !== "" && person.MaritalStatus === "1") {
                return true
            }
        }
        return false
    }

    removeBeneficiary(kt) {
        this.props.dispatch(removeSingleBeneficiary({ key: this.props.fieldName + "OrgId", value: kt}, this.props.customerId));
    }

    render() {
        const { customerId, customers, fieldName, initialValues, nationalRegistry } = this.props
        return (
            <>
                <div className={`${this.props.errors && this.props.errors.length > 0 ? 'error' : ''} form-row no-border align-items-center xs-mt-20`}>
                    <div className="col-12 col-xl-8">
                        <label className="col-12 col-xl d-xl-inline col-form-label pl-0">{this.props.label}</label>
                        {this.props.errors && this.props.errors.length > 0 ?
                            <span className="error"> ({this.props.errors}) </span> : ''
                        }
                        {/* <span className="col-12 col-xl p-0">{this.getDeathBenefitsBeneficiaryName(initialValues, customerId, customers, fieldName)}</span> */}
                    </div>
                    <div className="col-12 smoker">
                        <input type="radio" id={`deathBenefitsBeneficiary-10-${customerId}-${fieldName}`} name={fieldName} onClick={this.onChangeCheckbox} defaultChecked={initialValues[fieldName] === "10"} value={"10"} disabled={this.props.disabled} />
                        <label htmlFor={`deathBenefitsBeneficiary-10-${customerId}-${fieldName}`} className="col-sm-4 col-form-label">Lögerfingjar {getPersonAge(customerId) < 18 && 'tryggingaþega'}</label>
                    </div>
                    {this.hasSpouse() &&
                        <>
                            <div className="col-12 smoker">
                                <input type="radio" id={`deathBenefitsBeneficiary-20-${customerId}-${fieldName}`} name={fieldName} onClick={this.onChangeCheckbox} defaultChecked={initialValues[fieldName] === "20"} value={"20"} disabled={this.props.disabled} />
                                <label htmlFor={`deathBenefitsBeneficiary-20-${customerId}-${fieldName}`} className="col-sm-4 col-form-label">Maki</label>
                            </div>
                            <div className="col-12 smoker">
                                <input type="radio" id={`deathBenefitsBeneficiary-30-${customerId}-${fieldName}`} name={fieldName} onClick={this.onChangeCheckbox} defaultChecked={initialValues[fieldName] === "30"} value={"30"} disabled={this.props.disabled} />
                                <label htmlFor={`deathBenefitsBeneficiary-30-${customerId}-${fieldName}`} className="col-sm-4 col-form-label">Maki og börn (skiptist jafnt á milli)</label>
                            </div>

                        </>
                    }
                    <div className="col-sm-6 smoker">
                        <input type="radio" id={`deathBenefitsBeneficiary-40-${customerId}-${fieldName}`} name={fieldName} onClick={this.onChangeCheckbox} defaultChecked={initialValues[fieldName] === "40"} value={"40"} disabled={this.props.disabled} />
                        <label htmlFor={`deathBenefitsBeneficiary-40-${customerId}-${fieldName}`} className="col-sm-4 col-form-label">Tilnefna rétthafa</label>
                    </div>
                    <div className="col-sm-6 text-right">
                        { initialValues[fieldName] === "40" &&
                            <>
                                { !this.props.disabled &&
                                    
                                    <div className="taker-change btn btn-primary xs-ml-20"  data-toggle="modal" data-target={"#"+fieldName + "-" + customerId}>{(initialValues[fieldName] === "40" && initialValues[`${fieldName}OrgId`] !== "") ? "Bæta við rétthafa" : "Tilnefna rétthafa"}</div>
                                }

                            </>
                        }
                    </div>
                    {  initialValues[fieldName] === "40" && initialValues[`${fieldName}OrgId`].length > 0 &&
                        <div className="col-xs-12 beneficiary-container"> 
                            {initialValues[`${fieldName}OrgId`].length === 1 ? "Tilnefndur rétthafi: " : "Tilnefndir rétthafar: " }
                            <ul>
                            {initialValues[`${fieldName}OrgId`].map(person => 
                                <li>{customerNameById(person, this.props.customers)} <button type="button" onClick={() => this.removeBeneficiary(person)} className="btn btn-sm btn-danger">Fjarlægja</button></li>
                            )} 
                            </ul>
                            
                        </div>
                    }

                </div>

                <DeathbenefitsBeneficiaryModal id={fieldName + "-" + customerId} store={this.props.store} customerId={customerId} fieldName={fieldName} />
            </>
        )
    }
}

DeathBenefitsBeneficiary.defaultProps = {
    label: "Rétthafi dánarbóta"
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        nationalRegistry: {},
        infoCollection: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection

    return f;
}

export default connectWithStore(store, DeathBenefitsBeneficiary, mapStateToProps);
